import { z } from 'zod'

const lastWorkspaceSchema = z.object({
  orgId: z.string(),
  workspaceId: z.string(),
})

type LastWorkspace = z.infer<typeof lastWorkspaceSchema>

const storageKey = (profileId: string) => `lumoo:last-workspace:${profileId}`

/** A hint only: callers must check the workspace is still accessible. */
export function readLastWorkspace(profileId: string): LastWorkspace | null {
  try {
    const raw = localStorage.getItem(storageKey(profileId))
    if (!raw) {
      return null
    }
    const parsed = lastWorkspaceSchema.safeParse(JSON.parse(raw))
    return parsed.success ? parsed.data : null
  } catch {
    return null
  }
}

export function rememberLastWorkspace(
  profileId: string,
  lastWorkspace: LastWorkspace
) {
  try {
    localStorage.setItem(storageKey(profileId), JSON.stringify(lastWorkspace))
  } catch {
    // Storage can be unavailable (private mode, quota); the hint is optional.
  }
}
